import { SET_ALL_ERRORS } from "./actionTypes";

export const setAllErrorAction = (error: any) => {

    return {
        type: SET_ALL_ERRORS,
        payload: error
    };
};
